import { urlRegExp } from 'schemas'
import yup from './yup'

export const settingFormSchema = yup.object().shape({
  APP_TOS_URL: yup
    .string()
    .label('App TOS URL')
    .matches(urlRegExp, 'App TOS URL must be a valid URL')
    .trimmedRequired('App TOS URL is required'),
  recaptchaSecretKey: yup.string().trimmedRequired('Recaptcha Secret Key is required'),
  senderEmail: yup
    .string()
    .label('Sender Email')
    .email()
    .trimmedRequired('Sender Email is required'),
  password: yup.string().label('Password').trimmedRequired('Password is required'),
  smtpServer: yup.string().label('SMTP Server').trimmedRequired('SMTP Server is required'),
  appLogoURL: yup
    .string()
    .label('App Logo URL')
    .matches(urlRegExp, 'App Logo URL must be a valid URL')
    .trimmedRequired('App Logo URL is required'),
  subjectConfirmEmailSubject: yup
    .string()
    .label('Subject Confirmation Email Subject')
    .trimmedRequired('Subject Confirmation Email Subject is required'),
  subjectConfirmEmailBody: yup
    .string()
    .label('Subject Confirmation Email Body')
    .trimmedRequired('Subject Confirmation Email Body is required'),
  emailSubject: yup.string().label('Email Subject').trimmedRequired('Email Subject is required'),
  emailBody: yup.string().label('Email Body').trimmedRequired('Email Body is required'),
  confAdminWelcomeEmailSubject: yup.string().trimmedRequired('Email Subject is required'),
  confAdminWelcomeEmailBody: yup.string().trimmedRequired('Email Body is required'),
  subjectInviteEmailSubject: yup.string().trimmedRequired('Email Subject is required'),
  subjectInviteEmailBody: yup.string().trimmedRequired('Email Body is required'),
  subjectReminderEmailSubject: yup.string().trimmedRequired('Email Subject is required'),
  subjectReminderEmailBody: yup.string().trimmedRequired('Email Body is required'),
  speakerRemainderForTalksEmailSubject: yup.string().trimmedRequired('Email Subject is required'),
  speakerRemainderForTalksEmailBody: yup.string().trimmedRequired('Email Body is required'),
  aboutUsURL: yup
    .string()
    .label('About Us URL')
    .matches(urlRegExp, 'About Us URL must be a valid URL')
    .trimmedRequired('About Us URL is required'),
  talkReminderTime: yup.number().label('Talk Reminder Time').positive().required()
})

export const TemplateFormSchema = yup.object().shape({
  subject: yup.string().label('Subject').trimmedRequired('Email Subject is required'),
  body: yup.string().label('Body').trimmedRequired('Email Body is required')
})

export const generalSettingsFormSchema = yup.object().shape({
  havePolls: yup.boolean().label('Have Polls'),
  speakerCanUploadTalks: yup.boolean().label('Speaker Can Upload Talks'),
  enableAttendance: yup.boolean().label('Enable Attendance'),
  attendanceStartTime: yup
    .string()
    .label('Start Time')
    .when('enableAttendance', {
      is: true,
      then: yup.string().required('Start Time is required'),
      otherwise: yup.string()
    }),
  attendanceEndTime: yup
    .string()
    .label('End Time')
    .when('enableAttendance', {
      is: true,
      then: yup
        .string()
        .required('End Time is required')
        .test(
          'greater than start time',
          'End Time must be greater than Start Time',
          (value, context) => {
            const startValue = context.parent.attendanceStartTime
            const enableAttendance = context.parent.enableAttendance
            return enableAttendance
              ? new Date(value || 0).getTime() > new Date(startValue).getTime()
              : true
          }
        ),
      otherwise: yup.string()
    }),
  attendanceInfoMessage: yup
    .string()
    .label('Education Credit Explanation Message')
    .when('enableAttendance', {
      is: true,
      then: yup.string().required('Education Credit Explanation Message is required'),
      otherwise: yup.string()
    })
})
